import React from "react";
import Color from "../../data/Color";
import Flex from "../../data/Flex";
import UIButton from "../UIButton";
import UIFlex from "../UIFlex";
import UITitle from "../UITitle";
import Overlay from "./Overlay";
import './ConfirmOverlay.scss';

interface IConfirmOverlayDetails{
    title?:string | JSX.Element;
    message?:string | JSX.Element;
    confirmLabel?:string;
    confirmAction?:()=>void;
    cancelAction?:()=>void;
    cancelLabel?:string;
    hideCancel?:boolean;
}

interface IConfirmOverlayProps{
    hide:()=>void;
    details:IConfirmOverlayDetails;
}

export default class ConfirmOverlay extends React.Component<IConfirmOverlayProps>{

    static show=($id:string,$details:IConfirmOverlayDetails)=>{
        const hideOverlay = Overlay.show($id,{
            className:"confirmOverlay",
            maxWidth:330,
            content:(
                <ConfirmOverlay 
                    details={$details}                    
                    hide={()=>{
                        hideOverlay();
                    }}
                />
            ),         
            onBGClick:()=>{
                hideOverlay();
            }   
        });
        return hideOverlay;
    }
    
    static hide=($id:string)=>{
        Overlay.hide($id);
    }

    _no=()=>{
        this.props.hide();
        if(this.props.details.cancelAction){
            this.props.details.cancelAction();
        }
    }
    _yes=()=>{
        this.props.hide();
        if(this.props.details.confirmAction){
            this.props.details.confirmAction();
        }
    }

    render(){


        return (
            <UIFlex flex={{direction:Flex.COLUMN}}>
                {this.props.details.title && (
                    <UITitle title={this.props.details.title}/>
                )}
                <UIFlex className="message">
                    {this.props.details.message}
                </UIFlex>
                <UIFlex flex={{justifyContent:Flex.FLEX_END}} className="actions">
                    {!this.props.details.hideCancel && (
                        <UIButton color={Color.WHITE} label={this.props.details.cancelLabel || "No"}  onClick={this._no}/>
                    )}
                    <UIButton label={this.props.details.confirmLabel || "Yes"} onClick={this._yes}/>
                </UIFlex>
            </UIFlex>
        );
    }
}
